var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-5"},[_vm._v(" Перевод согласно текущему языку: "+_vm._s(_vm.itemsTranslated.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }